import axios, { Method } from 'axios';

const timeout: number = 30000;

export default class Client {
  static request(token: string | null, method: Method, uri: string, data: any, params: any) {
    const url = `https://api.weproov.com/v2/${uri}`;
    const headers = Client.headers(token);
    return axios({
      headers, method, timeout, url, data, params,
    });
  }

  static headers(token: string | null) {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    return token ? { ...headers, Authorization: token } : headers;
  }
}
